(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash/kebabCase"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash/kebabCase"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash/kebabCase")) : factory(root["lodash/kebabCase"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 